import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-product-label-data-details',
  templateUrl: './product-label-data-details.component.html',
  styleUrls: ['./product-label-data-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ProductLabelDataDetailsComponent {
  @Input() labelData: Record<string, unknown> | null = null;
  @Input() isLoading = false;
  @Input() errorMessage: string | null = null;
}
